export default function(amount) {
    const amt = Number(amount);
    return amt && amt.toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits:2}) || '0'
}
